import { render, staticRenderFns } from "./Ot-Approved-Reject-Dialog.vue?vue&type=template&id=6d716edf"
import script from "./Ot-Approved-Reject-Dialog.vue?vue&type=script&lang=js"
export * from "./Ot-Approved-Reject-Dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports